// require('Assets/vendor/ugc_uploader/ugcUploader.js');
import { QcloudUgckey, QcloudUgcvideoView, QcloudUgcvideoSave, QcloudUgcvideoInfo, QcloudUgcvideoWebview } from 'Services/getData';
export default {
    props: {
        maxSize: {
            type: Number,
            // 默认最大2G
            default: 2*1024*1024*1024
        }
    },
    data () {
        return {
            loading: false,
            videoId: '',
            previewUrl: '',
            
            // 腾讯云点播
            uploadStatus: 1,
            key: '',
            taskId: '',
            progressBar: 0,
            uploadCos: '',
            fileSize: '',
            fileName: '',
            speed: 0,
            uploadedFileSize: 0,
            prevProgressBar: 0,
            waitTime: '00:00:00',
            shacurr: 0,
            ugcPlayer: null,
            isDraft: false,
            videoInfo: {},
            fileId: '',
            startTime: Date.now()
        }
    },
    mounted () {

    },
    methods: {
        async getSignature (callback){
            let res = await QcloudUgckey();
            callback(res.data.data.signature);
        },
        addFile(e){
            let vue = this;
            let file = e.target.files[0];
            if(!file){
                return ;
            }
            if(/[:*?,<>\'\"\\]/g.test(file.name)){
                this.$alert(`文件名不得包含 / : * ? , " ' < > 等字符`);
                return;
            }
            
            this.fileSize = file.size;
            vue.fileName = file.name;
            if (!file) return;
            if(file.size > this.maxSize){
                this.$alert(`视频不能超过${this.conver(this.maxSize)}`);
                return ;
            }
            vue.$emit('addfile');
            // 分片上传文件
            vue.uploadStatus = 2;
            vue.startTime = Date.now();
            let prevDate = 0;
            let nowDate = 0;
            qcVideo.ugcUploader.start({
                videoFile: file, //视频，类型为 File
                getSignature: vue.getSignature, //前文中所述的获取上传签名的函数
                error: function(result){
                    if(!result.msg.includes('slice upload file error')){
                        vue.$common.reportVideoUpload(vue.startTime, vue.fileSize, 2);
                    }
                    console.log(`上传失败的文件类型：${  result.type}`);
                    vue.$alert(`上传失败的原因：${  result.msg}`)
                },
                progress: function(result){
                    if(!result.curr){
                        // 开始上传获取开始点的时间
                        prevDate = new Date().getTime();
                        nowDate = prevDate;
                        vue.startTime = Date.now();
                    }else{
                        nowDate = new Date().getTime();
                    }

                    if(result.curr == 0){
                        vue.shacurr = (result.shacurr*100).toFixed(2);
                        console.log(result.shacurr)
                    }else{
                        vue.shacurr = 0;
                    }
                    result.curr = Number(result.curr.toString().match(/^\d+(?:\.\d{0,2})?/))

                    let uploadDuration = nowDate - prevDate;
                    
                    vue.uploadedFileSize = vue.conver(result.curr * vue.fileSize);

                    vue.speed = result.curr * vue.fileSize / (uploadDuration/1000);

                    vue.progressBar = Math.ceil(result.curr * 100);
                    if(!result.curr){
                        vue.waitTime = '00:00:00';
                    }else{
                        vue.waitTime = vue.formatWaitTime(Math.ceil((1-result.curr)*vue.fileSize / vue.speed))
                    }
                    vue.uploadCos = result.cos;
                    vue.taskId = result.taskId;
                    vue.prevProgressBar = result.curr;
                    vue.speed = vue.conver(vue.speed);
                },
                finish: async function(result){
                    vue.$common.reportVideoUpload(vue.startTime, vue.fileSize, 1);
                    // 腾讯云视频预览地址
                    vue.completed(result.fileId, result.videoUrl);
                }
            });
        },
        async completed(fileId, videoUrl){
            let vue = this;
            this.fileId = fileId;
            this.previewUrl = videoUrl;
            vue.uploadStatus = 3;
        },
        async saveVideo(fileSize){
            let params = {
                fileId: this.fileId,
                url: this.previewUrl,
                name: this.fileName,
                size: fileSize
            }
            // 腾讯云视频保存
            let res = await QcloudUgcvideoSave(params);
            if(res.status == 200 && res.data.code == 0){
                this.videoId = res.data.data.id;
            }
            this.$emit('completed', {
                videoId: this.videoId,
                fileName: this.fileName,
                fileSize: fileSize,
                qcloudFileId: this.fileId,
                previewUrl: this.previewUrl
            });

            if(this.videoInfo.Duration){
                this.$emit('videoTime', parseInt(this.videoInfo.Duration));
            }else {
                this.$alert('获取视频时长失败，请手动填写时长');
                this.$emit('videoTime', '');
            }
            this.loading = false;
        },
        delVideo () {
            if((this.fileSize || this.videoInfo.Size) && this.uploadStatus == 2){
                this.$common.reportVideoUpload(
                    this.startTime,
                    this.fileSize ? this.fileSize : this.videoInfo.Size,
                    3,
                );
            }
            let vue = this;
            qcVideo.ugcUploader.cancel({
                cos: vue.uploadCos,   
                taskId: vue.taskId
            });
            this.$refs.videoInput.value = '';
            this.uploadStatus = 1;
            this.progressBar = 0;
            this.$emit('delVideo');
        },
        formatWaitTime (second) {
            return [parseInt(second / 60 / 60), parseInt(second / 60 % 60), second % 60].join(":")
                .replace(/\b(\d)\b/g, "0$1");
        },
        conver(limit){  
            if(!limit){
                limit = 0;
            }
            let size = "";  
            if( limit < 0.1 * 1024 ){ //如果小于0.1KB转化成B  
                size = `${limit.toFixed(1)  }B`;    
            }else if(limit < 0.1 * 1024 * 1024 ){//如果小于0.1MB转化成KB  
                size = `${(limit / 1024).toFixed(1)  }KB`;              
            }else if(limit < 0.1 * 1024 * 1024 * 1024){ //如果小于0.1GB转化成MB  
                size = `${(limit / (1024 * 1024)).toFixed(1)  }MB`;  
            }else{ //其他转化成GB  
                size = `${(limit / (1024 * 1024 * 1024)).toFixed(1)  }GB`;  
            }  
            
            let sizestr = `${size  }`;   
            let len = sizestr.indexOf("\.");  
            let dec = sizestr.substr(len + 1, 2);  
            if(dec == "00"){//当小数点后为00时 去掉小数部分  
                return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);  
            }  
            return sizestr;
        },
        async getDuration(videoDuration){
            // 获取时长
            let params = {
                fileId: this.fileId
            }
            let res = await QcloudUgcvideoInfo(params);
            if(res.status == 200 && res.data.code == 0){
                this.videoInfo = res.data.data;
            }
            if(this.videoInfo.Size){
                this.saveVideo(this.videoInfo.Size);
            }else if(videoDuration>=5){
                this.saveVideo(this.fileSize);
            }else{
                setTimeout(()=>{
                    this.getDuration(++videoDuration);
                }, 1000)
            }
        }
    },
    watch: {
        async uploadStatus(val){
            if(val == 3){
                if(!this.previewUrl){
                    return;
                }
                this.loading = true;
                this.getDuration(0);
            }
            if(val == 1){
                this.$emit('videoTime', '');
            }
        }
    }
}